import { generateRadixColors, getColorScaleCss } from 'radix-theme-generator'
import { useMemo } from 'react'
import { useDocumentHeadTags } from 'hooks/use-document-head-tags'
type Props = {
  accent?: string
}
export const ThemeColor = ({ accent = '#000000' }: Props): null => {
  const headTags = useMemo(() => {
    const resultLight = generateRadixColors({
      appearance: 'light',
      accent,
      gray: '#8B8D98',
      background: '#ffffff',
    })
    const resultDark = generateRadixColors({
      appearance: 'dark',
      accent,
      gray: '#8B8D98',
      background: '#31373e',
    })
    // Output both light and dark mode
    return {
      style: [
        {
          type: 'text/css',
          cssText: `${getColorScaleCss({
            // Always override same preset theme
            name: 'indigo',
            isDarkMode: false,
            contrast: resultLight.accentContrast,
            scale: resultLight.accentScale,
            scaleWideGamut: resultLight.accentScaleWideGamut,
            scaleAlpha: resultLight.accentScaleAlpha,
            scaleAlphaWideGamut: resultLight.accentScaleAlphaWideGamut,
            surface: resultLight.accentSurface,
            surfaceWideGamut: resultLight.accentSurfaceWideGamut,
          })}
          
          ${getColorScaleCss({
            // Always override same preset theme
            name: 'indigo',
            isDarkMode: true,
            contrast: resultDark.accentContrast,
            scale: resultDark.accentScale,
            scaleWideGamut: resultDark.accentScaleWideGamut,
            scaleAlpha: resultDark.accentScaleAlpha,
            scaleAlphaWideGamut: resultDark.accentScaleAlphaWideGamut,
            surface: resultDark.accentSurface,
            surfaceWideGamut: resultDark.accentSurfaceWideGamut,
          })}`,
        },
      ],
    }
  }, [accent])
  useDocumentHeadTags(headTags)
  return null
}
